import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';
import ButtonEdit from 'utils/buttons/ButtonEdit';
import ProjectListItem from './components/ProjectListItem';

export const skeletonObj = {
  id: 1,
  status: 'asd',
  title: 'Texto de propiedad',
  address: `Texto para la dirección`,
  barrios: 'Texto para el barrio',
  price: '3123',
  expenses: 'Texto para las expensas',
  operation: `Operacion`,
  updated_at: 'Texto para la fecha',
  created_at: 'Texto para la fecha',
  type: 'Texto para el tipo',
  locality: 'Texto para la localidad',
  characteristics: {
    ambience: 10,
    bedrooms: 10,
    bathrooms: 10,
    toilettes: 10,
    garages: 10,
    floors: 10
  },
  surface: 'Texto para la superficie',
  share: 50,
  real_estate: {
    name: 'Texto para la inmobiliaria',
    branchOffice: [
      {
        id: 1,
        branch_office_name: 'Texto para Sucursal',
        isCentral: false,
        isActive: true,
        phoneNumber: '1234567890',
        openingHours: 'Texto para el horario',
        address: 'Texto para la dirección'
      }
    ]
  },
  actions: [<ButtonEdit key="skeleton-button" funcion={() => {}} />]
};

const ProjectsCards = ({
  projects,
  loading,
  propsLimit,
  selected,
  setSelected
}) => {
  const skeletonArr = Array(propsLimit).fill(skeletonObj);

  return (
    <Row
      className={classNames('g-2', {
        'loading-skeleton': loading
      })}
    >
      {!loading
        ? projects.map(project => (
            <ProjectListItem
              key={project.id}
              project={project}
              selected={selected}
              setSelected={setSelected}
            />
          ))
        : skeletonArr.map((project, index) => (
            <ProjectListItem key={index} project={project} loading />
          ))}
    </Row>
  );
};

ProjectsCards.propTypes = {
  projects: PropTypes.array,
  loading: PropTypes.bool,
  propsLimit: PropTypes.number.isRequired,
  selected: PropTypes.array.isRequired,
  setSelected: PropTypes.func.isRequired
};

export default ProjectsCards;
